import { render, staticRenderFns } from "./PlanogramProductList.vue?vue&type=template&id=18b2673b&scoped=true"
import script from "./PlanogramProductList.vue?vue&type=script&lang=js"
export * from "./PlanogramProductList.vue?vue&type=script&lang=js"
import style0 from "./PlanogramProductList.vue?vue&type=style&index=0&id=18b2673b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2673b",
  null
  
)

export default component.exports